"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SortDescending = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M16,8 L3,8 L3,6 C3,5.44771525 3.44771525,5 4,5 L16,5 L16,8 Z M4,7 L15,7 L15,6 L4,6 L4,7 Z M13,12 L3,12 L3,9 L13,9 L13,12 Z M4,11 L12,11 L12,10 L4,10 L4,11 Z M10,16 L3,16 L3,13 L10,13 L10,16 Z M4,15 L9,15 L9,14 L4,14 L4,15 Z M7,20 L4,20 C3.44771525,20 3,19.5522847 3,19 L3,17 L7,17 L7,20 Z M4,19 L6,19 L6,18 L4,18 L4,19 Z M19,18.2955205 L21.1503387,16.1564808 C21.3462654,15.9615836 21.662963,15.9620007 21.8583756,16.1574133 C22.053222,16.3522598 22.053222,16.6681682 21.8583756,16.8630147 L21.8576229,16.8637658 L18.5,20.2071068 L15.1504805,16.8641721 C14.9552185,16.669294 14.9549074,16.353023 15.1497855,16.157761 L15.1501328,16.1574133 C15.3454645,15.9620817 15.6621003,15.9618891 15.8576694,16.156983 L18,18.2941081 L18,5 L19,5 L19,18.2955205 Z" })));
};
SortDescending.displayName = 'SortDescending';
exports.default = SortDescending;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SortDescending.js.map